interface CustomerAccount {
    show_onboarding?: boolean | null | undefined;
}

export function loginRedirectRoute(customerAccount: CustomerAccount, redirectTo?: string | null) {
    if (redirectTo) {
        if (redirectTo === 'onboarding') {
            return '/onboarding';
        }

        if (redirectTo === 'planner') {
            return '/appointment';
        }

        if (redirectTo === 'profile_preferences') {
            return '/profile?profile_active_tab=preferences';
        }

        if (isInternalPath(redirectTo)) {
            return redirectTo;
        }
    }
    if (customerAccount.show_onboarding) {
        return '/onboarding';
    }
    return '/';
}

export function isInternalPath(path: string): boolean {
    return path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\');
}
